

export class RmRackPositionIdReq{
    rmRackPositionId:number;
}